import React, { useMemo } from 'react';
import { usePagination, useSortBy, useTable } from 'react-table';
import BasicSortableHeader from 'components/common/table/cells/BasicSortableHeader';
import CampaignsColumns, { SUPP_PREFIX } from '../CampaignsColumns';
import CampaignsSortMenuHeader from '../CampaignsSortMenuHeader';

const useCampaignsTable = ({ data, removeColumn, comparisonPeriod }) => {
  const columns = useMemo(
    () => CampaignsColumns(true, comparisonPeriod, removeColumn),
    [removeColumn, comparisonPeriod],
  );

  const table = useTable(
    {
      columns,
      data: data ? data.rows : [],
    },
    useSortBy,
    usePagination,
  );

  const headers = table.columns
    .map((col) => {
      if (col.supportColumn) return undefined;
      const Component = col.changeColumn
        ? CampaignsSortMenuHeader
        : BasicSortableHeader;
      return (
        <Component
          id={col.id}
          key={col.Header}
          testkey={col.Header}
          label={col.label}
          isSorted={col.isSorted}
          isSortedDesc={col.isSortedDesc}
          sortBy={table.toggleSortBy}
          changeColumn={
            col.changeColumn
            && table.columns.find((c) => c.id === `${SUPP_PREFIX}${col.id}`)
          }
        />
      );
    })
    .filter((val) => !!val);

  return {
    headers,
    table,
  };
};

export default useCampaignsTable;
